import React from "react";
import styles from "./PersonCard.module.scss";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../../api/sanityClient";

const builder = imageUrlBuilder(sanityClient);
const urlFor = (source) => builder.image(source);

const PersonCard = ({ person }) => {
  const { name, title, businessName, photoUrl } = person;
console.log(person);

  return (
    <div className={styles.personCard}>
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={name}
          className={styles.photo}
        />
      ) : (
        ""
      )}
      <div className={styles.textContainer}>
        <h2 className={styles.name}>{name}</h2>
        {title ? <p className={styles.title}>{title}</p>: ""}
        {businessName ? <p className={styles.business}>{businessName}</p>: ""}
      </div>
    </div>
  );
};

export default PersonCard;
